import { render } from "./OrgGroupForm.vue?vue&type=template&id=40b994d4&scoped=true&ts=true&lang=html"
import script from "./OrgGroupForm.vue?vue&type=script&lang=ts"
export * from "./OrgGroupForm.vue?vue&type=script&lang=ts"

import "./OrgGroupForm.vue?vue&type=style&index=0&id=40b994d4&scoped=true&lang=css"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b994d4"]])

export default __exports__